import React from 'react'
import { AboutBtns, AboutImg, AboutSection, Button, Container, Data, Desc, Info, InfoName, InfoTitle, Subtitle, Title } from './AboutStyles'
import { UilDownloadAlt } from '@iconscout/react-unicons'

function About() {
    return (
        <AboutSection className="about-section">
            <Title>About Me</Title>
            <Subtitle>My introduction</Subtitle>

            <Container>
                <AboutImg src="/img/about.jpg" alt=""/>

                <Data>
                    <Desc>
                        Web developer, with extensive knowledge working with 
                        React js and Nodejs to deliver quality and scalable 
                        web applications with sleek UI/UX.
                    </Desc>
                    <Info>
                        <div>
                            <InfoTitle>01+</InfoTitle>
                            <InfoName>Years <br/> experience</InfoName>
                        </div>
                        <div>
                            <InfoTitle>07+</InfoTitle>
                            <InfoName>Portfolio <br/> Projects</InfoName>
                        </div>
                        <div>
                            <InfoTitle>01+</InfoTitle>
                            <InfoName>Companies<br/> worked</InfoName>
                        </div>

                    </Info>
                    <AboutBtns>
                            <Button download="" to="#/assets/oji.pdf">
                                Download CV<UilDownloadAlt className="btn__icon" size="1.25rem"/>
                            </Button>
                    </AboutBtns>
                </Data>
            </Container>
        </AboutSection>
    )
}

export default About
